import styled from "styled-components";
import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import { DateRange } from '../../../../../components/common/DateRange';
import { useNavigate } from "react-router-dom";
import EstimateModal from "../Modal/EstimateModal";

interface GameBoxProps {
    game: OngoingGame;
    onClick?: () => void;
  }

  interface OngoingGame {
    gameProposalId: number;
    gameId: number;
    title: string;
    bannerUrl: string;
    startedAt: string;
    expiredAt: string;
  }
  

  const GameBoxContainer = styled.div`
  position: relative;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
`;

const ContentBox = styled.div`
  border-radius: 5px;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 300px;
  min-width: 300px;
  flex-shrink: 0;
`;

const GameBox = styled(ContentBox)`
  flex-direction: column;
  padding: 20px;
  justify-content: flex-end;
  align-items: flex-start;
  position: relative;
  background-color: white;
  // height: 0vh;
  // height: 400px;
`;


const BannerImage = styled.div<{ url: string }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 220px;
  background-image: 
    linear-gradient(180deg, rgba(255,255,255,0) 70%, rgba(255,255,255,1) 100%),
    ${({ url }) => `url(${url})`};
  background-size: cover;
  background-position: center;
  border-radius: 5px 5px 0 0;
`;

const GameOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 230px;
  background: linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.3) 30%, rgba(0,0,0,0) 100%);
  border-radius: 5px 5px 0 0;
`;

const DefaultBanner = styled.div`
  position: absolute;
  top: 0%;
  left: 0;
  right: 0;
  height: 70%;
  background: linear-gradient(180deg, #E7E7E7 0%, #FEFEFE 100%);
  border-radius: 5px 5px 0 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  text-align: center;
`;

const DefaultText = styled.p`
  font-size: 15px;
  color: #999;
  margin: 0 0 0 0;
`;
const MoreButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: none;
  background-color: #EBF5FF;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #666666;
  z-index: 2;
  
  &:hover {
    background-color: #f5f5f5;
  }
`;

const DropdownMenu = styled.div<{ isVisible: boolean }>`
  position: absolute;
  top: 50px;
  right: -10px;
  background-color: #EBF5FF;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
  z-index: 3;
`;

const MenuItem = styled.button`
  padding: 15% 20px;
  background: none;
  border: none;
  text-align: left;
  font-size: 14px;
  color: #555555;
  cursor: pointer;
  width: 100%;
  display: block;
  border-radius: 8px;
  // z-index: 100;
  
  &:hover {
    background-color: #f5f5f5;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #f0f0f0;
  }
`;

const ContentInfo = styled.div`
  padding-top: 30px;
  margin-top: auto;
  height:42%;
  width: 100%;
`;

const GameTitle = styled.h3`
  color: black;
  font-size: 18px;
  font-weight: 600;
  z-index: 1;
  margin: 0 0 12px 0;
  position: relative;
  margin-top: 10px;
  padding-top: 20px;
  // padding-bottom: 20px;
`;

const GameDate = styled.p`
  color: #666666;
  font-size: 14px;
  margin: 0 0 12px 0;
  margin-top: 10px;
  z-index: 1;
    position: relative;
`;

export default function OngoingGameBox({ game, onClick }: GameBoxProps) {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isEstimateModalOpen, setIsEstimateModalOpen] = useState(false);
  const navigate = useNavigate();
  
  // 드롭다운 외부 클릭 시 닫기 로직 수정
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      // 클릭된 요소가 드롭다운 메뉴나 버튼의 자식이 아닌 경우에만 닫기
      const target = e.target as Node;
      const dropdownElement = document.querySelector('[data-dropdown="menu"]');
      const buttonElement = document.querySelector('[data-dropdown="button"]');
      
      if (isDropdownVisible && 
          dropdownElement && 
          buttonElement && 
          !dropdownElement.contains(target) && 
          !buttonElement.contains(target)) {
        setIsDropdownVisible(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isDropdownVisible]);
  
  const handleApprovedTestEdit = (e: React.MouseEvent) => {
    // 이벤트 전파 방지
    e.stopPropagation();
    navigate(`/home/test/modification/${game.gameId}`);
  };
  
  const handleEstimateModalOpen = (e: React.MouseEvent) => {
    // 이벤트 전파 방지
    e.stopPropagation();
    setIsEstimateModalOpen(true);
  };

  return (
    <GameBoxContainer onClick={onClick} style={{ cursor: 'pointer' }}>
      <GameBox>
        {game.bannerUrl && game.bannerUrl !== "" ? (
          <>
            <BannerImage url={game.bannerUrl} />
            <GameOverlay />
          </>
        ) : (
          <DefaultBanner>
            <DefaultText>이미지 등록 필요.</DefaultText>
          </DefaultBanner>
        )}
        <MoreButton
          data-dropdown="button"
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            setIsDropdownVisible(!isDropdownVisible);
          }}
        >
          <FontAwesomeIcon icon={faEllipsisH} />
        </MoreButton>
        <DropdownMenu 
          data-dropdown="menu"
          isVisible={isDropdownVisible} 
          onClick={(e: React.MouseEvent) => e.stopPropagation()}
        >
          <MenuItem onClick={handleEstimateModalOpen}>테스트 견적서 확인</MenuItem>
          <MenuItem onClick={handleApprovedTestEdit}>테스트 수정하기</MenuItem>
        </DropdownMenu>
        <ContentInfo>
          <GameTitle>{game.title}</GameTitle>
          <GameDate>
            <DateRange startDate={game.startedAt} endDate={game.expiredAt} />
          </GameDate>
        </ContentInfo>
      </GameBox>
      
      {/* 견적서 모달 */}
      <EstimateModal
        isOpen={isEstimateModalOpen}
        onClose={() => {
          setIsEstimateModalOpen(false);
        }}
        gameProposalId={game.gameProposalId}
      />
    </GameBoxContainer>
  );
}